<ng-container>
  <goa-header caption="Court Case Management Digital Service"></goa-header>

  <div class="container">
    <router-outlet></router-outlet>
  </div>

  <goa-footer></goa-footer>
</ng-container>
